import { Component, OnInit, TemplateRef } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { coloursUser } from 'app/models/user-model';
import { UserDataService } from 'app/services/user-data.service';
import { Department, Enterprise } from 'app/models/enterprise-model';
import { InitialiseService } from 'app/services/initialise.service';
import { ProjServiceService } from 'app/services/proj-service.service';
import { EntServiceService } from 'app/services/ent-service.service';
import { WriteService } from 'app/services/writes.service';
import { IconsService } from 'app/services/icons.service';
import { ChatService } from 'app/services/chat.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.css']
})
export class EnterpriseComponent implements OnInit {

  public search = true;
  public mSearch = true;
  public create = true;
  public mCreate = true;
  public next = true;
  public mNext = true;
  public loading = false;
  public mloading = false;
  public joining = false;
  public joiningComp = false;
  public showDpts = true;
  public editComp = false;
  showCompanies: boolean = false;
  tagItems = [];
  results: any;
  myDocument: AngularFirestoreDocument<coloursUser>;
  value = '';
  setEnterprise: Enterprise;
  setCustomer: any = { name: '', srTag: '' };
  enterprise: Enterprise;
  compUser = { bus_email: '', nationality: '', nationalId: '', phoneNumber: '', name: '', id: '' };
  country_arr = [];
  message = '';
  msgErr = false;
  psnmessage = '';
  psnMsgErr = false;
  dpt: Department;
  department: Department;
  departments = [];
  modalRef2: any;

  constructor(public afAuth: AngularFireAuth, public afs: AngularFirestore, public usd: UserDataService, public is: InitialiseService,
    public ps: ProjServiceService, public es: EntServiceService, public ws: WriteService, public ico: IconsService, public cs: ChatService, public modalService: NgbModal) {
    this.country_arr = is.country_arr;
    this.setEnterprise = this.enterprise = this.is.getnewEnterprise();
    this.enterprise.services = []
    this.dpt = this.department = is.getDeptInit();
    this.usd.champ = this.usd.acc;
  }

  getData() {
    this.compUser = {
      id: this.usd.acc?.id,
      name: this.usd.acc.name,
      bus_email: this.usd.acc.bus_email,
      phoneNumber: this.usd.acc.phoneNumber,
      nationalId: this.usd.acc.nationalId,
      nationality: this.usd.acc.nationality
    }
  }
  
  openLgg(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.open(template, { size: 'lg' })
  }

  dataCall() { }

  ngOnInit(): void {
  }

  resetEnt() {
    this.create = !this.create;
    console.log(this.create);
    this.enterprise = this.is.getSelectedCompany();
  }

  loadWait() {
    this.loading = !this.loading;
    setTimeout(() => {
      this.loading = !this.loading;
      this.next = !this.next;
      this.create = !this.create;
      this.loadClear()
    }, 3000);
  }

  loadClear() {
    setTimeout(() => {
      this.enterprise = {
        name: '', IndustrialSectorDocument: '', createdOn: '', updatedStatus: false, id: '', bus_email: '', location: '', logoURL: '',
        participants: null, champion: null, address: '', telephone: '', services: [], taxDocument: '', HnSDocument: '', by: '', byId: '',
        targetMonthlyIncome: '', actualMonthlyIncome: '', balanceSheet: '', actualAnnualIncome: '', targetAnnualIncome: '', sector: ''
      };
    }, 3000);
  }

  checkFields() {
    console.log(this.enterprise, this.enterprise.services);
    if (this.enterprise.name === '' || this.enterprise.location === '' || this.enterprise.sector === '' ||
      this.enterprise.services.length === 0) {
      this.message = 'NB* Please fill in all blank fields';
      this.msgErr = true;
    } else {
      this.msgErr = true;
      // this.message = '100%';
      this.message = '';
      if (this.is.isMob()) {
        // this.mNext = !this.mNext;
      } else {
        // this.next = !this.next;
      }
    }
  }

  psnFields() {
    console.log(this.enterprise, this.enterprise.services);
    console.log(this.enterprise, this.enterprise.services);
    if (this.enterprise.telephone === '' || this.enterprise.address === '' || this.compUser.name === '' || this.compUser.phoneNumber === ''
      || this.compUser.bus_email === '' || this.compUser.nationalId === '' || this.compUser.nationality === '') {
      this.psnmessage = 'NB* Please fill in all blank fields';
      this.psnMsgErr = true;
    } else {
      this.psnMsgErr = true;
      // this.message = '100%';
      this.psnmessage = '';
    }
  }

  async saveDept(dpt) {
    console.log(dpt);
    this.showDpts = true;
    console.log(this.setEnterprise);
    dpt.companyName = this.setEnterprise.name;
    dpt.companyId = this.setEnterprise.id;
    this.department = await this.ws.addDept(dpt);
    console.log(this.department);
  }
}
